// removed by extract-text-webpack-plugin
module.exports = {"registerPage":"_2qGobDjhZI0AbE8kcA0FRV","header":"_3dp1IKN1VgqVV7jf3pcoxe","registerForm":"_13a13SiB81n9HSgcKFjzcD","textCenter":"_1MJgKkNKp6TEZRMIGwk44V"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/Register.scss
// module id = 802
// module chunks = 0